import { useEffect } from "react";

import { useGetKycStatus } from "@/api/queries";
import FormError from "@/components/FormError";
import LoadingSmall from "@/components/LoadingSmall";
// import AppState from "@/store/appstate";
import useAppStore from "@/store/appStateZustand";

import IdenfyIFrame from "./IdenfyIFrame";

function BeginSecurityCheck() {
  const authData = useGetKycStatus();
  useEffect(() => {
    // Set navigation items to disabled by default when entering security check
    useAppStore.setState({ navItemsEnabled: false });

    // Cleanup function to ensure navigation is re-enabled when component unmounts
    return () => {
      useAppStore.setState({ navItemsEnabled: true });
    };
  }, []);

  // Update navigation state based on auth data
  useEffect(() => {
    if (authData.isSuccess
      && (authData.data === undefined
        || authData.data === "undefined"
        || authData.data === null
        || !authData?.data?.authurl)) {
      // Re-enable navigation if we have no valid auth token
      useAppStore.setState({ navItemsEnabled: true });
    }
  }, [authData.isSuccess, authData.data]);
  return (
    <div>
      <div>
        <div>
          {authData.isLoading && <LoadingSmall />}
          {authData.isSuccess && authData.data !== undefined && authData.data !== "undefined" && authData.data !== null
            && authData?.data?.authurl != null
            && authData?.data?.authurl !== undefined ? (
                <IdenfyIFrame authToken={authData.data} />
              ) : (
                <FormError validationError="No auth token returned from api" />
              )}
        </div>
      </div>
    </div>
  );
}
export default BeginSecurityCheck;
